if (!customElements.get('tdp-description-toggle')) {
  customElements.define(
    'tdp-description-toggle',
    class TdpDescriptionToggle extends HTMLElement {
      constructor() {
        super();
        this.description = this.querySelector('[data-tdp-description]');
        this.button = this.querySelector('[data-tdp-description-toggle]');
        if (!this.description || !this.button) return;

        if (this.description.children.length <= 1) {
          this.description.classList.remove('is-collapsed');
          this.button.hidden = true;
          return;
        }

        this.button.addEventListener('click', () => this.toggle());
      }

      toggle() {
        const collapsed = this.description.classList.toggle('is-collapsed');
        this.button.textContent = collapsed ? this.button.dataset.labelMore : this.button.dataset.labelLess;
        const related = this.nextElementSibling;
        if (related && related.classList.contains('tdp-related-products')) {
          related.classList.toggle('tdp-related-products--desc-open', !collapsed);
        }
      }
    }
  );
}
